import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SendIcon from "@mui/icons-material/Send";
import { format } from "../utils/mask.utils";
import Timeline from "../components/timeline";
import TimelineItem from "../components/timeline-item";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";

import PendingIcon from "@mui/icons-material/Pending";
import PeopleIcon from "@mui/icons-material/People";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import FolderDeleteIcon from "@mui/icons-material/FolderDelete";
import CheckIcon from "@mui/icons-material/Check";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import CancelIcon from "@mui/icons-material/Cancel";

import moment from "moment";

import StatusUtils from "../utils/status.utils";
import PerfilUtils from "../utils/perfil.utils";
import isAutenticated from "../utils/isAuthenticated";

const getCookie = require("../utils/getCookie");

const PageContainer = styled.div`
  margin: 16px;
  padding: 32px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  box-shadow: 0px 0px 20px -18px #424242;
`;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div style={{ paddingTop: 16, paddingBottom: 16 }}>{children}</div>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const InadimplenteForm = (props) => {
  const { id } = props.match.params;

  const [openLoadingDialog, setOpenLoadingDialog] = useState(false);
  const [openMessageDialog, setOpenMessageDialog] = useState(false);
  const [message, setMessage] = useState("");
  const [value, setValue] = React.useState(0);
  const [openAccountMenu, setOpenAccountMenu] = useState(false);
  const [anchorElAccountMenu, setAnchorElAccountMenu] = useState(null);

  const [protocolo, setProtocolo] = useState("");
  const [fkTipoDevedor, setFkTipoDevedor] = useState("");
  const [fkNaturezaInclusao, setFkNaturezaInclusao] = useState("");
  const [fkSistema, setFkSistema] = useState("");
  const [fkStatus, setFkStatus] = useState("");
  const [codigoUnidade, setCodigoUnidade] = useState("");
  const [unidade, setUnidade] = useState("");
  const [codigoTurma, setCodigoTurma] = useState("");
  const [turma, setTurma] = useState("");
  const [inicio, setInicio] = useState("");
  const [termino, setTermino] = useState("");
  const [matricula, setMatricula] = useState("");
  const [aluno, setAluno] = useState("");
  const [situacaoDaTurma, setSituacaoDaTurma] = useState("");
  const [contrato, setContrato] = useState("");
  const [nParcelas, setNParcelas] = useState("");
  const [parcelaHash, setParcelaHash] = useState("");
  const [vencimento, setVencimento] = useState("");
  const [tempoDeAtrasoDias, setTempoDeAtrasoDias] = useState("");
  const [valorDaParcela, setValorDaParcela] = useState("");
  const [cpfCnpjResponsavelFinanceiro, setCpfCnpjResponsavelFinanceiro] =
    useState("");
  const [tipoResponsavelFinanceiro, setTipoResponsavelFinanceiro] =
    useState("");
  const [nomeResponsavelFinanceiro, setNomeResponsavelFinanceiro] =
    useState("");
  const [emailResponsavelFinanceiro, setEmailResponsavelFinanceiro] =
    useState("");
  const [dddResponsavelFinanceiro, setDddResponsavelFinanceiro] = useState("");
  const [telefoneReponsavelFinanceiro, setTelefoneReponsavelFinanceiro] =
    useState("");
  const [logradouroReponsavelFinanceiro, setLogradouroReponsavelFinanceiro] =
    useState("");
  const [numeroResponsavelFinanceiro, setNumeroResponsavelFinanceiro] =
    useState("");
  const [bairroReponsavelFinanceiro, setBairroReponsavelFinanceiro] =
    useState("");
  const [cepReponsavelFinanceiro, setCepReponsavelFinanceiro] = useState("");
  const [cidadeReponsavelFinanceiro, setCidadeReponsavelFinanceiro] =
    useState("");
  const [ufReponsavelFinanceiro, setUfReponsavelFinanceiro] = useState("");
  const [segmento, setSegmento] = useState("");
  const [formaDePagamento, setFormaDePagamento] = useState("");
  const [dataPagamento, setDataPagamento] = useState("");
  const [alunoDtNascimento, setAlunoDtNascimento] = useState("");
  const [dddAluno, setDddAluno] = useState("");
  const [telefoneAluno, setTelefoneAluno] = useState("");
  const [endereco, setEndereco] = useState("");
  const [numero, setNumero] = useState("");
  const [cep, setCep] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [uf, setUf] = useState("");
  const [situacaoDoAluno, setSituacaoDoAluno] = useState("");
  const [cpfDoAluno, setCpfDoAluno] = useState("");
  const [rgDoAluno, setRgDoAluno] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");
  const [timeline, setTimeline] = useState([]);
  const [status, setStatus] = useState("");
  const [openConfirmarEnvio, setOpenConfirmarEnvio] = useState(false);
  const [tipoProcessamento, setTipoProcessamento] = useState("");
  const [logged, setLogged] = useState(null);
  const [openDialogXML, setOpenDialogXML] = useState(false);
  const [fkMotivoExclusao, setFkMotivoExclusao] = useState("");
  const [motivoExclusao, setMotivoExclusao] = useState([]);

  const [redirect, setRedirect] = useState(false);

  const [descricao, setDescricao] = useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    isAutenticated().then((_) => {
      if (_.data) {
        setLogged(_.data.data);
      } else {
        setLogged(null);
      }
    });
  });

  useEffect(() => {
    function carregarRegistro() {
      setOpenLoadingDialog(true);
      const token = getCookie("_token_spc_manager");
      const params = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/${id}`,
        params
      ).then((response) => {
        const { status } = response;
        response
          .json()
          .then((data) => {
            setOpenLoadingDialog(false);
            if (status === 401) {
              // setMessage(data.message)
              // setOpenMessageDialog(true)
            } else if (status === 200) {
              setOpenLoadingDialog(false);
              setProtocolo(data.data.protocolo);
              setFkTipoDevedor(data.data.fkTipoDevedor);
              setFkNaturezaInclusao(data.data.fkNaturezaInclusao);
              setFkSistema(data.data.fkSistema);
              setFkStatus(data.data.fkStatus);
              setCodigoUnidade(data.data.codigoUnidade);
              setUnidade(data.data.unidade);
              setCodigoTurma(data.data.codigoTurma);
              setTurma(data.data.turma);
              setInicio(data.data.inicio);
              setTermino(data.data.termino);
              setMatricula(data.data.matricula);
              setAluno(data.data.aluno);
              setSituacaoDaTurma(data.data.situacaoDaTurma);
              setContrato(data.data.contrato);
              setNParcelas(data.data.nParcelas);
              setParcelaHash(data.data.parcelaHash);
              setVencimento(data.data.vencimento);
              setTempoDeAtrasoDias(data.data.tempoDeAtrasoDias);
              setValorDaParcela(data.data.valorDaParcela);
              setCpfCnpjResponsavelFinanceiro(
                data.data.cpfCnpjResponsavelFinanceiro
              );
              setTipoResponsavelFinanceiro(data.data.tipoResponsavelFinanceiro);
              setNomeResponsavelFinanceiro(data.data.nomeResponsavelFinanceiro);
              setEmailResponsavelFinanceiro(
                data.data.emailResponsavelFinanceiro
              );
              setDddResponsavelFinanceiro(data.data.dddResponsavelFinanceiro);
              setTelefoneReponsavelFinanceiro(
                data.data.telefoneResponsavelFinanceiro
              );
              setLogradouroReponsavelFinanceiro(
                data.data.logradouroResponsavelFinanceiro
              );
              setNumeroResponsavelFinanceiro(
                data.data.numeroResponsavelFinanceiro
              );
              setBairroReponsavelFinanceiro(
                data.data.bairroResponsavelFinanceiro
              );
              setCepReponsavelFinanceiro(data.data.cepResponsavelFinanceiro);
              setCidadeReponsavelFinanceiro(
                data.data.cidadeResponsavelFinanceiro
              );
              setUfReponsavelFinanceiro(data.data.ufResponsavelFinanceiro);
              setSegmento(data.data.segmento);
              setFormaDePagamento(data.data.formaDePagamento);
              setDataPagamento(data.data.dataPagamento);
              setAlunoDtNascimento(data.data.alunoDtNascimento);
              setDddAluno(data.data.dddAluno);
              setTelefoneAluno(data.data.telefoneAluno);
              setEndereco(data.data.endereco);
              setNumero(data.data.numero);
              setCep(data.data.cep);
              setBairro(data.data.bairro);
              setCidade(data.data.cidade);
              setUf(data.data.uf);
              setSituacaoDoAluno(data.data.situacaoDoAluno);
              setCpfDoAluno(data.data.cpfDoAluno);
              setRgDoAluno(data.data.rgDoAluno);
              setCreatedAt(data.data.createdAt);
              setUpdatedAt(data.data.updatedAt);

              setTimeline(data.data.Timeline);
              setStatus(data.data.Status.nome);
            }
          })
          .catch((err) => setOpenLoadingDialog(false));
      });
    }

    if (id) {
      carregarRegistro();
    }
  }, []);

  const carregarMotivoExclusao = () => {
    setOpenLoadingDialog(true);
    const token = getCookie("_token_spc_manager");
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/motivoexclusao/`,
      params
    ).then((response) => {
      const { status } = response;
      response
        .json()
        .then((data) => {
          setOpenLoadingDialog(false);
          setOpenConfirmarEnvio(true);
          setOpenAccountMenu(false);

          if (status === 401) {
            setMessage(data.message);
            setOpenMessageDialog(true);
          } else if (status === 200) {
            setFkMotivoExclusao("");
            setMotivoExclusao(data.data);
          }
        })
        .catch((err) => setOpenLoadingDialog(true));
    });
  };

  const btConfirmarProcessamento = () => {
    setOpenConfirmarEnvio(false);

    if (tipoProcessamento === "encaminharParaUnidade") {
      onEncaminharParaUnidade();
    } else if (tipoProcessamento === "encaminharParaOSPC") {
      encaminharParaOSPC();
    } else if (tipoProcessamento === "removerDoSPC") {
      removerDoSPC();
    } else if (tipoProcessamento === "cancelar") {
      cancelar();
    } else if (tipoProcessamento === "confirmacaoUnidade") {
      onConfirmacaoUnidade();
    } else if (
      tipoProcessamento === "encaminharParaCorrecaoDeInconsistencias"
    ) {
      onConfirmacaoUnidadeCorrigirInconsistencias();
    }
  };

  const removerDoSPC = () => {
    setOpenLoadingDialog(true);
    const token = getCookie("_token_spc_manager");
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        descricao,
        fkMotivoExclusao,
      }),
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/${id}/removerdospc`,
      params
    ).then((response) => {
      const { status } = response;
      response
        .json()
        .then((data) => {
          setOpenLoadingDialog(false);
          if (status === 401) {
            setMessage(data.message);
            setOpenMessageDialog(true);
          } else if (status === 200) {
            setMessage(data.message);
            setOpenMessageDialog(true);
            setRedirect(true);
          }
        })
        .catch((err) => setOpenLoadingDialog(true));
    });
  };

  const cancelar = () => {
    setOpenLoadingDialog(true);
    const token = getCookie("_token_spc_manager");
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        descricao,
      }),
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/${id}/cancelar`,
      params
    ).then((response) => {
      const { status } = response;
      response
        .json()
        .then((data) => {
          setOpenLoadingDialog(false);
          if (status === 401) {
            setMessage(data.message);
            setOpenMessageDialog(true);
          } else if (status === 200) {
            setMessage(data.message);
            setOpenMessageDialog(true);
            setRedirect(true);
          }
        })
        .catch((err) => setOpenLoadingDialog(true));
    });
  };

  const encaminharParaOSPC = () => {
    setOpenLoadingDialog(true);
    const token = getCookie("_token_spc_manager");
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        descricao,
        ids: [id]
      }),
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/encaminharparaospc`,
      params
    ).then((response) => {
      const { status } = response;
      response
        .json()
        .then((data) => {
          setOpenLoadingDialog(false);
          if (status === 401) {
            setMessage(data.message);
            setOpenMessageDialog(true);
          } else if (status === 200) {
            setMessage(data.message);
            setOpenMessageDialog(true);
            setRedirect(true);
          }
        })
        .catch((err) => setOpenLoadingDialog(true));
    });
  };

  const onEncaminharParaUnidade = () => {
    setOpenLoadingDialog(true);
    const token = getCookie("_token_spc_manager");
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        descricao,
        ids: [id]
      }),
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/encaminharparaunidade`,
      params
    ).then((response) => {
      const { status } = response;
      response
        .json()
        .then((data) => {
          setOpenLoadingDialog(false);
          if (status === 401) {
            setMessage(data.message);
            setOpenMessageDialog(true);
          } else if (status === 200) {
            setMessage(data.message);
            setOpenMessageDialog(true);
            setRedirect(true);
          }
        })
        .catch((err) => setOpenLoadingDialog(true));
    });
  };

  const onConfirmacaoUnidade = () => {
    setOpenLoadingDialog(true);
    const token = getCookie("_token_spc_manager");
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        descricao,
        ids: [id]
      }),
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/confirmacaounidade`,
      params
    ).then((response) => {
      const { status } = response;
      response
        .json()
        .then((data) => {
          setOpenLoadingDialog(false);
          if (status === 401) {
            setMessage(data.message);
            setOpenMessageDialog(true);
          } else if (status === 200) {
            setMessage(data.message);
            setOpenMessageDialog(true);
            setRedirect(true);
          }
        })
        .catch((err) => setOpenLoadingDialog(true));
    });
  };

  const onConfirmacaoUnidadeCorrigirInconsistencias = () => {
    setOpenLoadingDialog(true);
    const token = getCookie("_token_spc_manager");
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        descricao,
      }),
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/${id}/encaminharparaunidadecorrigirinconsistencias`,
      params
    ).then((response) => {
      const { status } = response;
      response
        .json()
        .then((data) => {
          setOpenLoadingDialog(false);
          if (status === 401) {
            setMessage(data.message);
            setOpenMessageDialog(true);
          } else if (status === 200) {
            setMessage(data.message);
            setOpenMessageDialog(true);
            setRedirect(true);
          }
        })
        .catch((err) => setOpenLoadingDialog(true));
    });
  };

  const confirmarProcessamento = (type) => {
    setOpenAccountMenu(false);
    setTipoProcessamento(type);

    if (type === "encaminharParaUnidade") {
      setDescricao(
        `Solicitamos a análise imediata dos dados cadastrais de inadimplência para adição a base SPC. Agradecemos pela colaboração.`
      );
    } else {
      setDescricao("");
    }

    if (type === "removerDoSPC") {
      carregarMotivoExclusao();
    } else {
      setOpenConfirmarEnvio(true);
    }
  };

  const renderProcessarMenu = (
    <Menu
      anchorEl={anchorElAccountMenu}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      id="positioned-inadimplente-process-icon-button"
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={openAccountMenu}
      onClose={() => setOpenAccountMenu(false)}
    >
      {logged ? (
        logged.Perfil.nome === PerfilUtils.Administrador ||
        logged.Perfil.nome === PerfilUtils["Contas a Receber"] ? (
          <>
            {status === StatusUtils["Não Processado"] ? (
              <MenuItem
                onClick={() => confirmarProcessamento("encaminharParaUnidade")}
                disableRipple
              >
                <div
                  style={{
                    minWidth: 120,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <HourglassTopIcon fontSize="small" />
                  <div style={{ paddingLeft: 16 }}>Encaminhar para Unidade</div>
                </div>
              </MenuItem>
            ) : (
              ""
            )}

            {status === StatusUtils["Não Processado"] ||
            status === StatusUtils["Confirmado pela Unidade"] ? (
              <MenuItem
                onClick={() => confirmarProcessamento("encaminharParaOSPC")}
                disableRipple
              >
                <div
                  style={{
                    minWidth: 120,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <AccountBalanceIcon fontSize="small" />
                  <div style={{ paddingLeft: 16 }}>Encaminhar para o SPC</div>
                </div>
              </MenuItem>
            ) : (
              ""
            )}

            {status === StatusUtils["Confirmado pela Unidade"] ? (
              <MenuItem
                onClick={() =>
                  confirmarProcessamento(
                    "encaminharParaCorrecaoDeInconsistencias"
                  )
                }
                disableRipple
              >
                <div
                  style={{
                    minWidth: 120,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <AccountBalanceIcon fontSize="small" />
                  <div style={{ paddingLeft: 16 }}>
                    Corrigir Inconsistências
                  </div>
                </div>
              </MenuItem>
            ) : (
              ""
            )}

            {status === StatusUtils["Adicionado ao SPC"] ||
            status === StatusUtils["Pendente de Remoção do SPC"] ? (
              <MenuItem
                onClick={() => confirmarProcessamento("removerDoSPC")}
                disableRipple
              >
                <div
                  style={{
                    minWidth: 120,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <FolderDeleteIcon fontSize="small" />
                  <div style={{ paddingLeft: 16 }}>Remover do SPC</div>
                </div>
              </MenuItem>
            ) : (
              ""
            )}

            {status === StatusUtils["Não Processado"] ||
            status === StatusUtils["Confirmado pela Unidade"] ? (
              <MenuItem
                onClick={() => confirmarProcessamento("cancelar")}
                disableRipple
              >
                <div
                  style={{
                    minWidth: 120,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <CancelIcon fontSize="small" />
                  <div style={{ paddingLeft: 16 }}>Cancelar</div>
                </div>
              </MenuItem>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )
      ) : (
        ""
      )}

      {logged ? (
        status === StatusUtils["Aguardando Confirmação da Unidade"] &&
        logged.Perfil.nome === PerfilUtils.Funcionário ? (
          <MenuItem
            onClick={() => confirmarProcessamento("confirmacaoUnidade")}
            disableRipple
          >
            <div
              style={{ minWidth: 120, display: "flex", flexDirection: "row" }}
            >
              <CheckIcon fontSize="small" />
              <div style={{ paddingLeft: 16 }}>Confirmar</div>
            </div>
          </MenuItem>
        ) : (
          ""
        )
      ) : (
        ""
      )}

      {logged ? (
        status === StatusUtils["Aguardando Confirmação da Unidade"] &&
        logged.Perfil.nome === PerfilUtils.Funcionário ? (
          <MenuItem
            onClick={() => confirmarProcessamento("cancelar")}
            disableRipple
          >
            <div
              style={{ minWidth: 120, display: "flex", flexDirection: "row" }}
            >
              <CancelIcon fontSize="small" />
              <div style={{ paddingLeft: 16 }}>Cancelar</div>
            </div>
          </MenuItem>
        ) : (
          ""
        )
      ) : (
        ""
      )}

      {logged ? (
        status === StatusUtils["Com inconsistências"] &&
        logged.Perfil.nome === PerfilUtils.Funcionário ? (
          <MenuItem
            onClick={() => confirmarProcessamento("confirmacaoUnidade")}
            disableRipple
          >
            <div
              style={{ minWidth: 120, display: "flex", flexDirection: "row" }}
            >
              <CheckIcon fontSize="small" />
              <div style={{ paddingLeft: 16 }}>Confirmar</div>
            </div>
          </MenuItem>
        ) : (
          ""
        )
      ) : (
        ""
      )}

      {logged ? (
        status === StatusUtils["Com inconsistências"] &&
        logged.Perfil.nome === PerfilUtils.Funcionário ? (
          <MenuItem
            onClick={() => confirmarProcessamento("cancelar")}
            disableRipple
          >
            <div
              style={{ minWidth: 120, display: "flex", flexDirection: "row" }}
            >
              <CancelIcon fontSize="small" />
              <div style={{ paddingLeft: 16 }}>Cancelar</div>
            </div>
          </MenuItem>
        ) : (
          ""
        )
      ) : (
        ""
      )}
    </Menu>
  );

  return (
    <PageContainer>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 16,
        }}
      >
        <h3>Cadastro de Inadimplente</h3>
        {status ? (
          <div
            style={{
              paddingRight: 8,
              paddingLeft: 8,
              borderRadius: 5,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#eeeeee",
              border: "1px solid #e0e0e0",
              color: "#212121",
              marginLeft: 8,
              fontSize: 11,
              fontWeight: "bold",
            }}
          >
            {status}
          </div>
        ) : (
          ""
        )}
        {/* <div style={{paddingRight: 8, paddingLeft: 8, borderRadius: 5, backgroundColor: '#673ab7', color: '#d1c4e9', marginLeft: 8, fontSize: 11, fontWeight: 'bold'}}>Não Processado</div> */}
        <div style={{ flex: 1 }}></div>
        {logged ? (
          <div>
            {((status === StatusUtils["Não Processado"] ||
              status === StatusUtils["Confirmado pela Unidade"] ||
              status === StatusUtils["Adicionado ao SPC"]) &&
              logged.Perfil.nome === PerfilUtils.Administrador) ||
            logged.Perfil.nome === PerfilUtils["Contas a Receber"] ||
            ((status === StatusUtils["Aguardando Confirmação da Unidade"] ||
              status === StatusUtils["Com inconsistências"]) &&
              logged.Perfil.nome === PerfilUtils.Funcionário) ? (
              <Button
                size="medium"
                variant="outlined"
                startIcon={<BuildCircleIcon />}
                id="positioned-inadimplente-process-icon-button"
                color="inherit"
                disableElevation
                onClick={(e) => {
                  setAnchorElAccountMenu(e.currentTarget);
                  setOpenAccountMenu(true);
                }}
              >
                Processar
              </Button>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        {renderProcessarMenu}
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <FormGroup>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Timeline" {...a11yProps(0)} />
                {/* <Tab label="Aluno" {...a11yProps(1)} /> */}
                <Tab label="Informações" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <Timeline>
                {timeline.map((item, index) => (
                  <TimelineItem key={index} item={item} />
                ))}
              </Timeline>
            </TabPanel>
            {/* <TabPanel value={value} index={1}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <TextField
                  size="small"
                  fullWidth
                  label="Protocolo"
                  disabled
                  variant="standard"
                  value={protocolo}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="CPF"
                    variant="standard"
                    value={cpfDoAluno}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Aluno"
                    variant="standard"
                    value={aluno}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Matrícula"
                    variant="standard"
                    value={matricula}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Contrato"
                    variant="standard"
                    value={contrato}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <TextField
                  size="small"
                  disabled
                  fullWidth
                  label="Unidade"
                  variant="standard"
                  value={unidade}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Cód. Turma"
                    variant="standard"
                    value={codigoTurma}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Turma"
                    variant="standard"
                    value={turma}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Início"
                    variant="standard"
                    value={inicio}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Término"
                    variant="standard"
                    value={termino}
                  />
                </div>
              </div>
            </TabPanel> */}
            <TabPanel value={value} index={1}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <TextField
                  size="small"
                  fullWidth
                  label="Protocolo"
                  disabled
                  variant="standard"
                  value={protocolo}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="CPF"
                    variant="standard"
                    value={cpfDoAluno}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Aluno"
                    variant="standard"
                    value={aluno}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Matrícula"
                    variant="standard"
                    value={matricula}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Contrato"
                    variant="standard"
                    value={contrato}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <TextField
                  size="small"
                  disabled
                  fullWidth
                  label="Unidade"
                  variant="standard"
                  value={unidade}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Cód. Turma"
                    variant="standard"
                    value={codigoTurma}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Turma"
                    variant="standard"
                    value={turma}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Início"
                    variant="standard"
                    value={inicio}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Término"
                    variant="standard"
                    value={termino}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Tipo"
                    variant="standard"
                    value={tipoResponsavelFinanceiro}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Nome Responsável Financeiro"
                    variant="standard"
                    value={nomeResponsavelFinanceiro}
                  />
                </div>
              </div>
              <div style={{ flex: 1, marginBottom: 16 }}>
                <TextField
                  size="small"
                  disabled
                  fullWidth
                  label="CPF/CNPJ"
                  variant="standard"
                  value={cpfCnpjResponsavelFinanceiro}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Email"
                    variant="standard"
                    value={emailResponsavelFinanceiro}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Telefone"
                    variant="standard"
                    value={telefoneReponsavelFinanceiro}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Contrato"
                    variant="standard"
                    value={contrato}
                  />
                </div>
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Nº Parcelas"
                    variant="standard"
                    value={nParcelas}
                  />
                </div>
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Vencimento"
                    variant="standard"
                    value={vencimento}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Valor"
                    variant="standard"
                    value={valorDaParcela ? format(valorDaParcela) : ""}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="CEP"
                    variant="standard"
                    value={cepReponsavelFinanceiro}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Endereço"
                    variant="standard"
                    value={logradouroReponsavelFinanceiro}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 16,
                }}
              >
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Número"
                    variant="standard"
                    value={numeroResponsavelFinanceiro}
                  />
                </div>
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Bairro"
                    variant="standard"
                    value={bairroReponsavelFinanceiro}
                  />
                </div>
                <div style={{ flex: 1, marginRight: 16 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="Cidade"
                    variant="standard"
                    value={cidadeReponsavelFinanceiro}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    size="small"
                    disabled
                    fullWidth
                    label="UF"
                    variant="standard"
                    value={ufReponsavelFinanceiro}
                  />
                </div>
              </div>
            </TabPanel>
          </Box>

          {/* <div style={{flex: 1, marginBottom: 16}}>
            <TextField size="small" disabled fullWidth label="Aluno" variant="standard" value={aluno}  onChange={e => setAluno(e.target.value)}/>
          </div> */}

          <div style={{ flex: 1, display: "flex", flexDirection: "row" }}>
            <Button variant="outlined" onClick={() => window.history.back()}>
              Voltar
            </Button>
            <div style={{ flex: 1 }}></div>
          </div>
        </FormGroup>
      </div>

      <Dialog open={openLoadingDialog}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: 120,
            height: 120,
          }}
        >
          <CircularProgress />
        </div>
      </Dialog>

      <Dialog
        open={openMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Atenção</DialogTitle>
        <DialogContent style={{ width: 500 }}>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={
              redirect
                ? () => window.location.reload()
                : () => setOpenMessageDialog(false)
            }
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openConfirmarEnvio}>
        <DialogTitle>
          {tipoProcessamento === "encaminharParaUnidade"
            ? "Encaminhando para Unidade"
            : ""}
          {tipoProcessamento === "encaminharParaOSPC"
            ? "Encaminhando para o SPC"
            : ""}
          {tipoProcessamento === "removerDoSPC" ? "Removendo do SPC" : ""}
          {tipoProcessamento === "cancelar" ? "Cancelamento" : ""}
          {tipoProcessamento === "confirmacaoUnidade" ? "Confirmação" : ""}
          {tipoProcessamento === "encaminharParaCorrecaoDeInconsistencias"
            ? "Correção de Inconsistências"
            : ""}
        </DialogTitle>
        <DialogContent style={{ width: 500 }}>
          <DialogContentText>
            {/* {tipoProcessamento === 'encaminharParaUnidade' ? 'Você está prestes a encaminhar este registro, para análise da unidade.' : ''}
            {tipoProcessamento === 'encaminharParaOSPC' ? 'Encaminhando para o SPC' : ''}
            {tipoProcessamento === 'removerDoSPC' ? 'Removendo do SPC' : ''}
            {tipoProcessamento === 'cancelar' ? 'Cancelamento' : ''} */}
            {tipoProcessamento === "encaminharParaCorrecaoDeInconsistencias"
              ? "Você confirma o encaminhamento do registro para que a unidade educacional responsável prossiga com a análise e correção de inconsistências?"
              : ""}
            {tipoProcessamento === "encaminharParaUnidade"
              ? "Você confirma o encaminhamento do registro para que a unidade educacional responsável prossiga com a análise?"
              : ""}
            {tipoProcessamento === "encaminharParaOSPC" ||
            tipoProcessamento === "confirmacaoUnidade"
              ? "Você confirma que o registro atende aos critérios de inadimplência e que deve ser enviado ao Serviço de Proteção de Crédito (SPC)?"
              : ""}
            {tipoProcessamento === "cancelar"
              ? "O processo de cancelamento estabelece ao indivíduo um prazo de 30 dias para a execução das negociações, caso o seguinte registro continue inadimplente, automáticamente será reclassificado como não processado, iniciando um novo ciclo de avaliação."
              : ""}
          </DialogContentText>
          <div style={{ marginBottom: 8, marginTop: 8 }}>
            {tipoProcessamento === "removerDoSPC" ? (
              <div>
                <label style={{ fontSize: 15 }}>Motivo da Exclusão</label>
                <select
                  style={{
                    height: 48,
                    outline: "none",
                    border: "1px solid #e0e0e0",
                    borderRadius: 3,
                    marginTop: 8,
                  }}
                  onChange={(e) =>
                    setFkMotivoExclusao(
                      e.target.options[e.target.selectedIndex].value
                    )
                  }
                >
                  <option></option>
                  {motivoExclusao.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.descricao}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              // <FormControl fullWidth size="small">
              //   <InputLabel id="demo-multiple-name-label2">Motivo da Exclusão</InputLabel>

              //   <Select
              //       fullWidth
              //       labelId="demo-multiple-name-label2"
              //       id="demo-multiple-name2"
              //       label="Motivo Exclusão"
              //       value={fkMotivoExclusao}
              //       margin="dense"
              //       variant='standard'>
              //       {motivoExclusao.map((item, index) => <MenuItem key={index} value={item.id} onClick={() => setFkMotivoExclusao(item.id)}>{item.descricao}</MenuItem>)}
              //     </Select>
              // </FormControl>
              ""
            )}
          </div>
          <TextField
            autoFocus
            margin="dense"
            fullWidth
            multiline
            label="Justificativa"
            rows={2}
            variant="standard"
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmarEnvio(false)}>Cancelar</Button>
          <Button onClick={btConfirmarProcessamento}>Enviar</Button>
        </DialogActions>
      </Dialog>
    </PageContainer>
  );
};

export default InadimplenteForm;
